
import mixin from "./mixin";
import { Component, Mixins } from "vue-property-decorator";
import * as modals from "@/lib/modals";
import { getModule } from "vuex-module-decorators";
import notifications from "../../../lib/notifications";
import BarcodeSystemModule from "@/store/modules/barcodeSystem";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { AccountModule, SystemModule } from "@/store/modules";
import LoadModule from "@/store/modules/barcodeSystem/load";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import StockOrderModule from "@/store/modules/barcodeSystem/stockOrder";

const barcodeSystemModuleState = getModule(BarcodeSystemModule);
const inventoryModuleState = getModule(InventoryModule);
const loadModuleState = getModule(LoadModule);
const systemModuleState = getModule(SystemModule)
const accountModuleState = getModule(AccountModule);
const barcodeOrderModuleState = getModule(BarcodeOrderModule);
const stockOrderModuleState = getModule(StockOrderModule);
const manifestModuleState = getModule(ManifestModule);

@Component({ name: modals.barcodeSystemCurrentFacilityModal})
export default class BarcodeSystemCurrentFacilityModal extends Mixins(mixin) {
  localFacilityCode: string = null;

  get currentFacilityCode() {
    return barcodeSystemModuleState.currentFacilityCode;
  }

  created() {
    if(systemModuleState.facilities && systemModuleState.facilities.length == 1)
    {
      this.localFacilityCode = systemModuleState.facilities[0].facilityCode;
    }
    else if(this.currentFacilityCode)
    {
      this.localFacilityCode = JSON.parse(JSON.stringify(this.currentFacilityCode));
    }
    else if(systemModuleState.facilities && systemModuleState.facilities.length > 1)
    {
      this.localFacilityCode = systemModuleState.facilities[0].facilityCode;
    }
    barcodeSystemModuleState.setCurrentFacilityCode(this.localFacilityCode);
  }

  async submit() {
    try {
      await accountModuleState.updateUserSettings({
        settingName: "barcodeSystemCurrentFacilityCode",
        values: [this.localFacilityCode]
      });      
      inventoryModuleState.resetData();
      loadModuleState.resetData();
      barcodeOrderModuleState.resetData();
      stockOrderModuleState.resetData();
      manifestModuleState.resetData();
      await barcodeSystemModuleState.setCurrentFacilityCode(this.localFacilityCode);
      this.hideModal();
    } catch (ex) {
      notifications.error("Select Facility", "Failed to set barcode system facility.", ex);
    }
  }
}
